import React from "react";
import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";

// material-ui icons
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
//page components
import DataFilteringList from "./DataFilteringList";
import TableList from "./TableList"
import { dfConfigActions } from 'actions';
const style = {
  customCardContentClass: {
    paddingLeft: "0",
    paddingRight: "0"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const pageStyle = { ...style, ...sweetAlertStyle };

class DataFilteringConfigContainer extends React.Component {
  
  async componentDidMount(){
    const { dispatch } = this.props;
    // console.log('componentDidMount')
    dispatch( await dfConfigActions.getTableConfig()); 
}
  
    render() {
      const { formInitialValue, dispatch, fieldsList } = this.props;
      formInitialValue.tableName = fieldsList
      
        return (
          <div>
              <Card >
                <CardBody>
                  <CustomSweetAlert />
                  <GridContainer>
                    <GridItem xs={12}>
                      <TableList initialValues={formInitialValue}  />
                      {/* <DatafilteringConfig initialValues={formInitialValue}  /> */}
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
          </div>
        )
    }
}
function mapStateToProps(state) {
  const { formInitialValue, formOpen, newdatabaseFieldsList } = state.tableTemplateList;
  return { formInitialValue, formOpen, fieldsList :newdatabaseFieldsList };
}

export default connect(mapStateToProps)(withStyles(pageStyle)(DataFilteringConfigContainer));

